import { render, staticRenderFns } from "./PrescriptionPrint.vue?vue&type=template&id=c73ff68c&scoped=true&"
import script from "./PrescriptionPrint.vue?vue&type=script&lang=js&"
export * from "./PrescriptionPrint.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionPrint.vue?vue&type=style&index=0&id=c73ff68c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c73ff68c",
  null
  
)

export default component.exports